/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConversionStatistics,
    ConversionStatisticsFromJSON,
    ConversionStatisticsFromJSONTyped,
    ConversionStatisticsToJSON,
} from './ConversionStatistics';

/**
 * 
 * @export
 * @interface ConversionsOverviewItem
 */
export interface ConversionsOverviewItem {
    /**
     * 
     * @type {number}
     * @memberof ConversionsOverviewItem
     */
    localityId: number;
    /**
     * 
     * @type {Array<ConversionStatistics>}
     * @memberof ConversionsOverviewItem
     */
    items: Array<ConversionStatistics>;
}

export function ConversionsOverviewItemFromJSON(json: any): ConversionsOverviewItem {
    return ConversionsOverviewItemFromJSONTyped(json, false);
}

export function ConversionsOverviewItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversionsOverviewItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'localityId': json['locality_id'],
        'items': ((json['items'] as Array<any>).map(ConversionStatisticsFromJSON)),
    };
}

export function ConversionsOverviewItemToJSON(value?: ConversionsOverviewItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locality_id': value.localityId,
        'items': ((value.items as Array<any>).map(ConversionStatisticsToJSON)),
    };
}

